import { refs, dispatchEvent } from '../modules/utils.js';

class VideoBox extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) {
  }

  async connectedCallback() {
    await new Promise(resolve => setTimeout(resolve, 0));
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    this.refs.play?.addEventListener('click', () => {
      dispatchEvent('videobox:play', {
        src: this.refs.play.dataset.src,
        title: this.refs.play.dataset.title,
      });
    });
  }
}

customElements.define('video-box', VideoBox);
